import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { handleError } from '@/services/errorHandler.js'
import * as API from '@/services/api.js'
import { useCreativeAiChat } from '@/context-state/CreativeAiChatContext.jsx'

export const ChatDataProvider = () => {

    const { aiSettings, setAiSettings } = useCreativeAiChat()

    useEffect(() => {
        if (!aiSettings.isFetched) {
            fetchAiSettings()
        }
    }, [])

    const fetchAiSettings = async () => {
        try {
            const [instructionsResponse, knowledgeResponse, brandResponse] = await Promise.all([
                API.getAiInstructions(),
                API.getAiKnowledge(),
                API.getAiContextBrand()
            ])
            setAiSettings({
                instructions: instructionsResponse.data || [],
                knowledge: knowledgeResponse.data || [],
                hasBrandContext: !!brandResponse.data,
                isFetched: true,
            })
        } catch (e) {
            handleError(e)
        }
    }

    return <Outlet />
}
